<template>
  <div :data-option_mode="isStore ? 'store' : 'shop'">
    <div
      v-for="(option, index) in options"
      :key="index">
      <ItemOption
        :locale="locale"
        :lang="lang"
        :shopResponsive="shopResponsive"
        :uniqueId="option.uniqueId"
        :shopItemId="shopItemId"
        :option="option"
        :cartOptionData="getPreOptionData(option)"
        :activeOptionId="activeOptionId"
        @updateSubOption="updateSubOption" />
    </div>
  </div>
</template>

<script>
import ItemOption from './ItemOption'

export default {
  name: 'shopDetailOptions',
  props: [
    'locale',
    'lang',
    'shopResponsive',
    'shopPageId',
    'shopItemId',
    'optionId',
    'options',
    'cartOptions',
    'activeOptionId'
  ],
  components: {
    ItemOption
  },
  computed: {
    isStore () {
      return this.$route.name === 'store'
    },
    getDetailOptions () {
      return this.$store.getters['shop/getDetailOptions']
    }
  },
  watch: {
    activeOptionId (uniqueId) {
      // 스토어:: 옵션탭이 변경되면 서브옵션 초기화
      this.subOption = null
    }
  },
  data () {
    return {
      subOption: null
    }
  },
  methods: {
    updateSubOption (data) {
      const subOption = data.subOption ? this.$store.getters['shop/getOptionListData'](this.shopPageId, this.shopItemId, Object.values(data.subOption), data.optionId, data.optionItemId) : null
      this.subOption = {
        ...data,
        subOption: subOption
      }
      if (subOption) {
        this.setDetailSubOption(subOption)
      }
    },
    setDetailSubOption (data) {
      const subOptionData = data.map(x => {
        const isCheckbox = x.type === 'checkbox'
        const isSelect = x.type === 'select'
        return {
          ...x.id && { // 스토어의 option.id + 프리셋의 optionIds[].id
            id: x.id
          },
          ...x.optionId && { // 상품에서 직접등록한 option
            optionId: x.optionId
          },
          parentOption: data.optionId,
          name: x.name,
          uniqueId: x.uniqueId,
          isValid: !x.isRequired,
          optionItems: x.optionItems.filter((o, i) => o.isDefault || (isSelect && i === 0)).map(o => {
            return {
              id: o.id,
              quantity: o.quantity,
              optionItemId: o.optionItemId,
              ...o.price && {
                price: o.price,
                totalPrice: o.price
              },
              ...o.pId && {
                pId: o.pId
              }
            }
          })
        }
      })
      this.$store.commit('shop/setDetailOptions', subOptionData)
    },
    isActiveSubOption (option) {
      const optionId = option.id || option.optionId
      // 서브옵션 데이터가 있는지?
      const subOptionData = this.subOption
      // 옵션id가 일치하는지?
      const isOptionId = subOptionData && subOptionData.optionId === optionId
      // 옵션 itemId가 일치하는지?
      const isOptionItemId = subOptionData && option.optionItems.find(x => x.optionItemId === subOptionData.optionItemId)
      return isOptionId && isOptionItemId
    },
    getPreOptionData (option) {
      const optionId = option.id || option.optionId
      const cartOption = this.cartOptions && this.cartOptions.find(x => (x.id || x.optionId) === optionId)
      return cartOption
    }
  }
}
</script>